export default "__VITE_ASSET__056b5331__"